import React from "react";

import {
	ToggleButton,
	Tooltip,
	mergeClasses,
} from "@fluentui/react-components";
import { SquareToggleButtonProps } from "./types";
import { useButtonStyle } from "@/components/atoms/squareToggleButton";

export const SquareToggleButton = (props: SquareToggleButtonProps) => {
	const [ref, setRef] = React.useState<HTMLElement | null>();
	const style = useButtonStyle();

	return (
		<>
			<Tooltip
				mountNode={ref}
				relationship="label"
				positioning={"below"}
				content={{ children: props.tooltip, className: style.tooltipContent }}
				children={
					<ToggleButton
						style={{ display: "flex", flexShrink: 0 }}
						className={mergeClasses(style.squareDefaultButton, props.className)}
						shape="square"
						icon={props.icon}
						onClick={props.onClick}
						disabled={props.disabled}
						checked={props.checked || false}	
					/>
				}
			/>

			<div ref={setRef}></div>
		</>
	);
};
